<template>
  <div v-if="getShowSpinner" class="spinner-overlay">
    <ion-spinner
      name="lines"
      :duration="spinnerDuration"
      :paused="spinnerPaused"
      :enabled="spinnerEnabled"
    ></ion-spinner>
    <p v-if="spinnerMessage" class="spinner-message">{{ spinnerMessage }}</p>
    <div v-if="spinnerProgress !== null" class="spinner-dots">
      <span v-for="i in filledDots" :key="i" class="dot"></span>
    </div>
  </div>
</template>

<script lang="ts">
import { IonSpinner } from "@ionic/vue";
import { computed, defineComponent, provide } from "vue";
import {
  isLoading,
  spinnerManager,
  spinnerMessage,
  spinnerProgress,
} from "@/globals/pages/spinnerControl";

// Cada ponto corresponde a 100 / SPINNER_DOTS % do progresso
const SPINNER_DOTS = 10;

export default defineComponent({
  name: "SpinnerOverlay",
  components: { IonSpinner },
  props: {
    showSpinner: {
      type: Boolean,
      default: false, // Change this value to control when to show/hide the spinner
    },
    spinnerName: {
      type: String,
      default: "lines", // Change this value if you want a different spinner style
    },
    spinnerDuration: {
      type: Number,
      default: 1000, // Change this value to specify a different duration in milliseconds
    },
    spinnerPaused: {
      type: Boolean,
      default: false, // Change this value to pause or resume the spinner animation
    },
    spinnerEnabled: {
      type: Boolean,
      default: true, // Change this value to enable or disable the spinner
    },
  },
  setup() {
    const filledDots = computed(() =>
      Math.floor((spinnerProgress.value ?? 0) * SPINNER_DOTS),
    );
    return {
      spinnerMessage,
      spinnerProgress,
      filledDots,
      SPINNER_DOTS,
    };
  },
  computed: {
    getShowSpinner() {
      return this.showSpinner || spinnerManager.isLoading.value;
    },
  },
});
</script>

<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(
    0,
    0,
    0,
    0
  ); /* Change the background color and opacity as needed */
  z-index: 99999;

  --color: var(--milage-color-primary-shade);
}
ion-spinner {
  width: 5rem;
  height: 5rem;
}

.spinner-overlay {
  flex-direction: column;
  gap: 12px;
}
.spinner-message {
  margin: 0;
  color: var(--milage-color);
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums; /* os números não dançam */
}
/* Entre o logo (50%) e o spinner de baixo da LoadingPage (bottom: 25%) */
.spinner-dots {
  position: absolute;
  top: 62.5%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 8px;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  animation: dot-appear 0.3s ease;
}
@keyframes dot-appear {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
@/globals/pages/spinnerControl
